// src/components/FormSettings/FormDesign/constants.js

export const DropZoneTypes = {
    ABOVE: 'above',
    BELOW: 'below',
    LEFT: 'left',
    RIGHT: 'right',
};

/**
 * Toggle for low-noise drag/drop instrumentation.
 * Keep false in prod; temporarily set true while diagnosing.
 */
export const DND_DEBUG = false;
